





































































































import {Component} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {ShrikeHelper} from '@/helpers/ShrikeHelper'

@Component({})
export default class BridgedGasBarSection extends MixinScreenSize {
  totalGas: number = 0
  usedGas: number = 0

  get percentage() {
    return (this.usedGas / this.totalGas) * 100
  }

  get formattedGas() {
    return `${this.usedGas.toLocaleString()} / ${this.totalGas.toLocaleString()}`
  }

  mounted() {
    this.populateBridgedGas()
  }

  async populateBridgedGas() {
    try {
      const {totalGas, usedGas} = await ShrikeHelper.getNativeBridge()

      this.totalGas = totalGas
      this.usedGas = usedGas
    } catch (error) {
      console.error('Error fetching bridged gas data:', error)
    }
  }
}
